import api from '@pray/shared/utils/api';

import type { WorkflowVersionResponse } from './data/response';

type GetLastVersionProps = {
  artistId: string;
  workflowId: string;
};

export async function getLastVersion({ artistId, workflowId }: GetLastVersionProps): Promise<WorkflowVersionResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions/last`;

  const response = await api.executeGetRequest<WorkflowVersionResponse>(url);
  return response.data;
}
